export default __webpack_public_path__ + "static/media/medium.a319ac31.svg";